import groupBy from "lodash/groupBy";
import { Component } from "react";
import { connect } from "react-redux";
import type {
  EventMarketType,
  EventType,
  MarketType,
} from "../../../../../../../../../../../types/eventType";
import Runner from "../Runner/Runner";
import "./MarketRunnerDetailsGrouped.scss";
type Props = {
  event: EventType;
  market: EventMarketType;
  marketType: MarketType;
  addBetSlip: (...args: Array<any>) => any;
  groupedBy: String;
};

class MarketRunnerDetailsGrouped extends Component<Props> {
  render() {
    const { event, market, marketType, groupedBy } = this.props;
    const groupedRunners = groupBy(market.runners, groupedBy);
    const groupNames = Object.keys(groupedRunners) || [];
    let dummy = "";

    if (groupNames.length === 1) {
      // means one side is missing runners so need to add a dummy market on the other side,
      // so that the market displays properly
      switch (groupNames && groupNames[0]) {
        case "YES":
          dummy = "NO";
          break;

        case "NO":
          dummy = "YES";
          break;

        case "OVER":
          dummy = "UNDER";
          break;

        case "UNDER":
          dummy = "OVER";
          break;
        case "HOME":
          dummy = "AWAY";
          break;
        case "AWAY":
          dummy = "HOME";
          break;

        default:
          break;
      }
    }

    return (
      <div className={"grouped-container"}>
        {dummy && dummy.length > 0 && (
          <div
            className={`grouped-market grouped-market--${dummy.toLowerCase()} `}
          ></div>
        )}
        {groupNames.map((groupName, i) => {
          return (
            <div
              key={`grouped_${market.id}_${i}`}
              className={`grouped-market grouped-market--${groupName.toLowerCase()} ${market.status.toLowerCase()} ${market.marketInternalType?.toLowerCase()}`}
            >
              {groupedRunners[groupName].map(runner => {
                const hasPrices =
                  runner["aggregatedPrices"] &&
                  runner["aggregatedPrices"].length > 0;

                if (!hasPrices) {
                  return (
                    <span
                      key={`grouped_${runner.id}_${i}`}
                      className={""}
                    ></span>
                  );
                }

                return (
                  <Runner
                    runner={runner}
                    index={runner.id}
                    event={event}
                    marketType={marketType}
                    key={"binary" + runner.id}
                  />
                );
              })}
            </div>
          );
        })}
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    addBetSlip: (betSlip: EventType) =>
      dispatch.betSlipListModel.addBetSlip(betSlip),
  };
}

export default connect(
  null,
  mapDispatchToProps
)(MarketRunnerDetailsGrouped) as any;
